import Vue from 'vue';

import { cloneDeep } from '@/utils/object';

export default class {
	constructor(parameters) {
		this.type = 'SET';
		this.params = parameters;
		this.oldData = undefined;
		this.redoData = undefined;
	}

	execute() {
		const {
			state,
			elementId,
			oldData,
		} = this.params;

		if (typeof this.redoData === 'undefined') {
			if (JSON.stringify(state.website.components[elementId]) === JSON.stringify(oldData)) {
				return false;
			}

			this.redoData = cloneDeep(state.website.components[elementId]);
		}

		this.oldData = oldData;

		Vue.set(state.website.components, elementId, this.redoData);

		return true;
	}

	undo() {
		const {
			state,
			elementId,
		} = this.params;

		Vue.set(state.website.components, elementId, this.oldData);
	}
}
